import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
export default function Cover() {
  return (
    <section className="h-screen grid overflow-hidden">
      <div className="col-start-1 row-start-1 z-0 relative">
        <StaticImage
          src="../../images/An7Mm1FI.png"
          className="h-screen object-cover w-full"
          alt="orchid"
        />
      </div>
      <div className="bg-black bg-opacity-25 col-start-1 row-start-1 z-10 relative h-screen grid items-center">
        <div className="max-w-6xl mx-auto w-11/12 xl:w-full">
          <div className="w-full lg:w-2/3 space-y-3 lg:space-y-6">
            <h1 className=" text-2xl  drop-shadow md:text-5xl font-bold text-white before:content-['“'] after:content-['”']">
              Home is where your story begins
            </h1>
            <p className="text-secondry text-sm drop-shadow">
              Our passion is to open new doors, doors of opportunities in Ibiza
            </p>
            <div>
              <Link
                to="/contact"
                className="px-8 py-3 shadow-lg shadow-amber-900/40 bg-secondry hover:shadow-lg hover:shadow-g-900/40   transition rounded duration-500 ease-in-out hover:bg-stone-800 hover:text-secondry text-primary uppercase text-sm font-bold"
              >
                Schedule a Call
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
